"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EOMONTH = void 0;
exports.EOMONTH = {
    alias: 'FIM_MES',
    description: 'Retorna o último dia do mês',
    arg_names: ['data_inicial', 'meses'],
    args_description: [
        'data de referência a partir da qual se deseja calcular',
        'quantidade de meses',
    ],
};
